import { render, staticRenderFns } from "./sxdg.vue?vue&type=template&id=eb304d06&scoped=true"
import script from "./sxdg.vue?vue&type=script&lang=js"
export * from "./sxdg.vue?vue&type=script&lang=js"
import style0 from "./sxdg.vue?vue&type=style&index=0&id=eb304d06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb304d06",
  null
  
)

export default component.exports